import produce from "immer";
import { v1 as uuid } from "uuid";
import { CustomizationState } from "../";
import { Configuration } from "../../../types/customization/configuration";
import { maxPageReached } from "../../../utils/customization/configuration";
import { findPageDefinition } from "../../../utils/customization/finders";
import {
  addPageMutation,
  generateNewPage,
  getNumberPagesToAdd,
} from "../../../utils/customization/page";
import { getMaxPageReachedMessage } from "../../../utils/customMessages";
import { addNotificationRemovingSameOnes } from "../../../utils/notification";

export interface AddPageAction {
  type: "addPage";
  configuration: Configuration | undefined;
  pageDefinitionKey: string;
  withFocus?: boolean;
}

export function addPage(state: CustomizationState, action: AddPageAction): CustomizationState {
  return produce(state, (draftState) => {
    doAddPage(draftState, action);
  });
}

export function doAddPage(draftState: CustomizationState, action: AddPageAction): void {
  const configuration = action.configuration;

  if (maxPageReached(draftState.content, configuration, draftState.template.pageDefinitions)) {
    const maxPagesMessage = getMaxPageReachedMessage(
      draftState.content.templateType,
      configuration
    );
    const notification = {
      code: "KFE-003",
      customMessage: maxPagesMessage,
      key: uuid(),
    };
    addNotificationRemovingSameOnes(draftState.notifications, notification);
    return;
  }

  const pageDefinition = findPageDefinition(action.pageDefinitionKey, draftState.template);
  const nbPagesToAdd = getNumberPagesToAdd(draftState.template, pageDefinition, configuration);

  for (let i = 0; i < nbPagesToAdd; i++) {
    const newPage = generateNewPage(
      pageDefinition.key,
      draftState.template,
      draftState.ui.defaultColorKey
    );
    addPageMutation(newPage, draftState.content);
  }

  if (action.withFocus) {
    draftState.ui.pageKeyToFocus =
      draftState.content.pages[draftState.content.pages.length - 1].key;
  }
}
